// Small line icons (24x24 viewBox, stroke = currentColor).

const PATHS = {
  play: 'M7 4.5v15l12-7.5z',
  star: 'M12 3.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6-5.4-3.1-5.4 3.1 1.2-6L3.3 9.8l6.1-.7z',
  search: 'M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM15.5 15.5L20 20',
  close: 'M6 6l12 12M18 6L6 18',
  download: 'M12 4v11M7 10.5l5 5 5-5M5 19.5h14',
  upload: 'M12 16V5M7 9.5l5-5 5 5M5 19.5h14',
  server: 'M4 5h16v5H4zM4 14h16v5H4zM7.5 7.5h.01M7.5 16.5h.01',
  back: 'M15 5l-7 7 7 7',
  chevron: 'M9 5l7 7-7 7',
  restart: 'M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 4.5v4h4',
  eye: 'M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12zM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
  exit: 'M10 5H5v14h5M14 8l4 4-4 4M18 12H9',
  box: 'M4 7.5L12 4l8 3.5v9L12 20l-8-3.5zM4 7.5l8 3.5 8-3.5M12 11v9',
  trash: 'M5 7h14M10 7V4.5h4V7M7 7l1 13h8l1-13',
  settings: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM19.4 13.5l1.6 1.2-1.8 3.1-1.9-.6a7.5 7.5 0 0 1-2 1.2L15 20.5h-3.6l-.4-2.1a7.5 7.5 0 0 1-2-1.2l-1.9.6-1.8-3.1 1.6-1.2a7.6 7.6 0 0 1 0-2.4l-1.6-1.3 1.8-3.1 1.9.6a7.5 7.5 0 0 1 2-1.2L11.4 3.5H15l.4 2.1a7.5 7.5 0 0 1 2 1.2l1.9-.6 1.8 3.1-1.6 1.3a7.6 7.6 0 0 1 0 2.4z',
  keyboard: 'M3 7h18v10H3zM6.5 10h.01M9.5 10h.01M12.5 10h.01M15.5 10h.01M17.5 10h.01M7.5 14h9',
  flag: 'M5 21V4M5 4h12l-2 4 2 4H5',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 6.5M18 14a6.5 6.5 0 0 1 3.5 6',
  crown: 'M4 18h16M4.5 15.5L3 7l5 4 4-6 4 6 5-4-1.5 8.5z',
  copy: 'M9 9h10v11H9zM5 15V4h10',
  lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  info: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 11v5M12 7.5h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 18, filled = false, class: cls }: { name: IconName; size?: number; filled?: boolean; class?: string }) {
  return (
    <svg class={`icon${cls ? ` ${cls}` : ''}`} width={size} height={size} viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
